import { Link } from "react-router-dom";
import { useSite } from "@/lib/site";
import { SubpageHeader } from "@/components/birthlife/SubpageHeader";
import { Footer } from "@/components/birthlife/Footer";
import { Breadcrumbs } from "@/components/birthlife/Breadcrumbs";
import { Seo, breadcrumbLd } from "@/lib/seo";

const TITLES = { terms: "Terms & Conditions", privacy: "Privacy Policy" };

export default function Legal({ page }) {
  const { content } = useSite();
  const text = content.pages?.[page]?.content || "Content is being prepared.";
  const crumbs = [{ label: TITLES[page], href: `/${page}/` }];

  return (
    <div data-testid={`${page}-page`} className="min-h-screen bg-sand">
      <Seo title={TITLES[page]} description={`${TITLES[page]} — The Birth Life, Yogyata Wadhwa IBCLC`} path={`/${page}/`} jsonLd={[breadcrumbLd(crumbs)]} />
      <SubpageHeader />
      <main className="mx-auto max-w-4xl px-4 py-12 sm:px-8 sm:py-16">
        <Breadcrumbs items={crumbs} />
        <h1 className="mt-8 font-display text-4xl font-medium tracking-tight text-ink sm:text-5xl" data-testid="legal-title">
          {TITLES[page]}
        </h1>
        <div className="mt-10 whitespace-pre-line pb-16 text-base leading-relaxed text-plumsoft" data-testid="legal-content">
          {text}
        </div>
      </main>
      <Footer />
    </div>
  );
}
